import { Component } from '@angular/core';

@Component({
  selector: 'app-bizzmine-tab',
  templateUrl: './bizzmine-tab.component.html',
  styleUrls: ['./bizzmine-tab.component.scss']
})
export class BizzmineTabComponent {
}
